export default "/images/logo-black.png?4f3cebfe43889b33fffffed0c0e26ffc";